const TARGET_VIEWS = {
    WINDOW: 1,
    IFRAME: 2
}

const REQUEST_METHODS = {
    POST: 'POST',
    GET: 'GET'
}

export {TARGET_VIEWS, REQUEST_METHODS};